export const SET_USER_DETAIL = "SET_USER_DETAIL";
export const SET_LANGUAGE_LIST = "SET_LANGUAGE_LIST";
export const CHANGE_UUID = "CHANGE_UUID";
export const RELOAD_PAGE = "RELOAD_PAGE";
export const SET_SELECTED_NEARME = "SET_SELECTED_NEARME";
export const RESET_SELECTED_NEARME = "RESET_SELECTED_NEARME";
export const SELECTED_LANGUAGE = "SELECTED_LANGUAGE";
export const TOUR_GUIDE = "TOUR_GUIDE";
export const CLONING_FLAG = "CLONING_FLAG";
export const Feedback_Mod = "Feedback_Mod";
export const SETFILTER_FLAG = "SETFILTER_FLAG";
export const SETFILTER_DATA = "SETFILTER_DATA";
export const SETDOWNLOAD_PDF = "SETDOWNLOAD_PDF";
export const RESETDOWNLOAD_PDF = "RESETDOWNLOAD_PDF";
export const RESETFILTER_PDF = "RESETFILTER_PDF";
export const ACTIVE_CLL_TAB = "ACTIVE_CLL_TAB";
export const SET_CASE_LOCATION = "SET_CASE_LOCATION";
export const SET_SELECTED_SERVICE = "SET_SELECTED_SERVICE";
export const SET_DEMOGRAPHICSDATA = "SET_DEMOGRAPHICSDATA";
export const SET_CUMLATIVE_FILTER = "SET_CUMLATIVE_FILTER";
export const SET_TOTAL_APP_DOWNLOADS = "SET_TOTAL_APP_DOWNLOADS";
export const SET_TOTAL_PEOPLE_ENGAGED = "SET_TOTAL_PEOPLE_ENGAGED";
export const SET_URLS = "SET_URLS";
export const STORE_URLS = "STORE_URLS";
export const APPLY_SURVEY_FILTER = "APPLY_SURVEY_FILTER";
export const RESET_SURVEY_FILTER = "RESET_SURVEY_FILTER";
export const SET_DOWNLOAD_CLM_PDF = "SET_DOWNLOAD_CLM_PDF";
export const SET_CHECK_ALL_CHART_LOAD = "SET_CHECK_ALL_CHART_LOAD";
export const SET_SURVEY_MEDIA = "SET_SURVEY_MEDIA";
export const SET_INBOX_DRAWER = "SET_INBOX_DRAWER";
export const SET_SERVICE_INDICATOR = "SET_SERVICE_INDICATOR";
export const SET_SELECTED_DROPDOWN_SERVICE = "SET_SELECTED_DROPDOWN_SERVICE";
export const SET_SURVEY_ID_DROPDOWN_VALUE = "SET_SURVEY_ID_DROPDOWN_VALUE";